module.exports = __webpack_public_path__ + "static/img/avatar.bd0706d1.png";